export default __webpack_public_path__ + "static/media/100_19422.27658f2e.jpg";